import { isNull } from '../../izUtils';
import Swal from 'sweetalert2';

export const handleError = (error, navigate) => {
    console.log("error:", error)

    if (!isNull(navigate) && error.error_code === 'general_terms') {
        navigate("/splosni-pogoji")
    }

    Swal.fire({
        text: error.message,
        icon: "error",
        confirmButtonColor: '#96B448',
        confirmButtonText: 'OK'
    }).then(() => {
        if (isNull(navigate)) return;

        switch (error.error_code) {
            case 'auth_unauthenticated':
                navigate("/")
                break;
            case 'auth_gate':
                if (window.history.length > 1) {
                    navigate(-1)
                } else {
                    navigate("/")
                }
                break;
        }
    })
}